// src/components/Loader.js
import { Spinner } from "react-bootstrap";

const Loader = () => (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
    <Spinner animation="border" variant="light" />
  </div>
);

export default Loader;
